import { Button } from 'antd';
import styled from 'styled-components';

export const FlexContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  &> div {
    width: 100%;
    margin-bottom: 20px;
  }

  @media screen and (hover: none) and (orientation: landscape) {
    flex-flow: row wrap;

    &> div {
      width: 50%;

      &:nth-child(odd){
        padding-right: 24px;
      }
    }
  }
`;


export const LogoutButton = styled(Button)`
  position: absolute;
  bottom: 0;
  right: 0;
`;

export const Wrapper = styled.div`
  width: 100%;
  min-height: calc(100vh - 185px);
  position: relative;
  padding-bottom: 60px;
  margin-bottom: 70px;
`;
